export default "__VITE_PUBLIC_ASSET__999617d4__"